/**
 * Unique identifier for the ApiCredentials feature group.
 */
export const API_CREDENTIALS_FEATURE_GROUP_ID = "API_CREDENTIALS_FEATURE_GROUP";
